// @flow
import styled from 'styled-components';

export const SearchInputWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 36px;
	box-shadow: 0 2px 8px 2px rgba(0,0,0,0.04);
`;

export default SearchInputWrapper;


// WEBPACK FOOTER //
// ./src/components/SearchInputWrapper/index.js